import { cn } from '@/lib/utils';
import { forwardRef } from 'react';

interface ResponsiveContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  centerContent?: boolean;
}

const ResponsiveContainer = forwardRef<HTMLDivElement, ResponsiveContainerProps>(
  ({ children, className, padding = 'md', maxWidth = '2xl', centerContent = false, ...props }, ref) => {
    const paddingClasses = {
      none: '',
      sm: 'px-4',
      md: 'px-4 sm:px-6',
      lg: 'px-4 sm:px-6 lg:px-8',
    };

    const maxWidthClasses = {
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      '2xl': 'max-w-screen-2xl',
      full: '',
    };

    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto w-full',
          paddingClasses[padding],
          maxWidth !== 'full' && maxWidthClasses[maxWidth],
          centerContent && 'flex flex-col items-center',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

ResponsiveContainer.displayName = 'ResponsiveContainer';

export { ResponsiveContainer };
export type { ResponsiveContainerProps };